/**
 * THE INVOICE LIST REMEMBERS WHERE YOU LEFT IT.
 *
 * Jesse, 2026-10-06: *"if I click on an invoice and then come back to invoices
 * my current filter isn't retained."* The list keeps its tab, client, search,
 * sort and page in the URL, so the browser's Back button always returned to
 * the same view — but the "← Invoices" link above an invoice pointed at bare
 * `/invoices`, which is the default Open tab for every client.
 *
 * The list writes its own query string here on every change; the links that
 * lead back to it read it. The path is fixed, so nothing stored can send the
 * reader anywhere but `/invoices` (the `?back=<url>` open redirect BackLink
 * warns about cannot happen). It is per tab and per session, and a read or a
 * write that fails (private window, blocked storage) falls back to the plain
 * list.
 */

const KEY = 'financials:invoices:list-view';

/** Called by the list with its current query string (`''` for the default view). */
export function rememberInvoiceListView(search: string): void {
  try {
    const query = new URLSearchParams(search).toString();
    if (query) window.sessionStorage.setItem(KEY, query);
    else window.sessionStorage.removeItem(KEY);
  } catch {
    // Storage unavailable — the link simply goes to the default view.
  }
}

/** `/invoices` as the reader last left it in this session. */
export function invoiceListHref(): string {
  try {
    const query = window.sessionStorage.getItem(KEY);
    if (query) return `/invoices?${new URLSearchParams(query).toString()}`;
  } catch {
    // fall through
  }
  return '/invoices';
}
